import { render, staticRenderFns } from "./FieldsetButton.vue?vue&type=template&id=420818b1&"
import script from "./FieldsetButton.vue?vue&type=script&lang=ts&"
export * from "./FieldsetButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports